import styled, { css } from 'styled-components';
import { Row, Column } from 'components/shared/Layout';

import { colours } from 'themes/default';

export const Cell = styled(Column)`
  /*font-size: clamp(12px, 1.1vw, 20px);*/

  > a {
    color: ${colours.Greyscale.CharcoalGrey};
  }
`;

export const TableRow = styled(Row)`
  padding: 8px 0;
  margin: 0;
  border-bottom: solid 1px ${colours.Greyscale.MistGrey};

  ${({ position }) => {
    if (position) {
      return css`
        position: relative;
      `;
    }

    return css``;
  }}
`;

export const Table = styled(Row)`
  padding: 16px;
  box-shadow: 0px 0px 30px ${colours.Greyscale.MistGrey};

  ${TableRow} {
    &:nth-child(2n + 1) {
      background: ${colours.Shades.TintBlue10};
    }
  }
`;

export const TableHeader = styled(Row)`
  font-weight: bold;
  padding-bottom: 8px;
  border-bottom: solid 1px ${colours.Greyscale.Black};
`;
